<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Koljeność produktów po kategorii'">
        <template slot="content" slot-scope="{ setLoading }">
          <products-sort @loading="setLoading" />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import ProductsSort from '@/components/VNFR/ProductsSort/ProductSort.vue'

export default {
  name: 'ProductsSortList',
  components: {
    Ibox,
    ProductsSort
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
